import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';

export default function Permissions() {
  const navigate = useNavigate();
  const [locationGranted, setLocationGranted] = useState(false);
  const [notificationGranted, setNotificationGranted] = useState(false);
  
  const handleLocationPermission = () => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        () => setLocationGranted(true),
        () => alert('Platstillstånd krävs för att använda appen')
      );
    }
  };
  
  const handleNotificationPermission = () => {
    if ('Notification' in window) {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          setNotificationGranted(true);
        }
      });
    }
  };
  
  const handleContinue = () => {
    navigate('/jobs');
  };
  
  return (
    <div className="relative h-screen bg-white flex flex-col px-6 pt-16">
      <div className="mb-8">
        <div className="w-16 h-16 bg-[#E31837] rounded-full flex items-center justify-center mb-6">
          <i className="ri-shield-check-line text-3xl text-white"></i>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Behörigheter</h1>
        <p className="text-base text-gray-600">
          Vi behöver dessa behörigheter för att ge dig bästa upplevelsen
        </p>
      </div>
      
      <div className="space-y-4 mb-8">
        <div className="bg-white rounded-2xl p-4 border-2 border-gray-200">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-map-pin-line text-xl text-blue-600"></i>
            </div>
            <div className="flex-1">
              <h3 className="text-base font-bold text-gray-900 mb-1">Platsåtkomst</h3>
              <p className="text-sm text-gray-600 mb-3">
                Krävs för att visa leveransrutter och spåra din position i realtid
              </p>
              {locationGranted ? (
                <div className="flex items-center gap-2 text-green-600">
                  <i className="ri-checkbox-circle-fill text-lg"></i>
                  <span className="text-sm font-semibold">Beviljad</span>
                </div>
              ) : (
                <Button
                  onClick={handleLocationPermission}
                  variant="primary"
                  size="small"
                >
                  Aktivera plats
                </Button>
              )}
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-2xl p-4 border-2 border-gray-200">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-notification-3-line text-xl text-purple-600"></i>
            </div>
            <div className="flex-1">
              <h3 className="text-base font-bold text-gray-900 mb-1">Aviseringar</h3>
              <p className="text-sm text-gray-600 mb-3">
                Få meddelanden om nya order, uppdateringar och viktiga händelser
              </p>
              {notificationGranted ? (
                <div className="flex items-center gap-2 text-green-600">
                  <i className="ri-checkbox-circle-fill text-lg"></i>
                  <span className="text-sm font-semibold">Beviljad</span>
                </div>
              ) : (
                <Button
                  onClick={handleNotificationPermission}
                  variant="secondary"
                  size="small"
                >
                  Aktivera aviseringar
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
      
      <div className="bg-blue-50 rounded-2xl p-4 mb-8">
        <div className="flex items-start gap-3">
          <i className="ri-information-line text-lg text-blue-600 mt-0.5"></i>
          <div>
            <p className="text-sm text-blue-900 font-semibold mb-1">Integritet & GDPR</p>
            <p className="text-xs text-blue-800 leading-relaxed">
              Dina platsdata används endast under aktiva leveranser och lagras säkert enligt GDPR. 
              Du kan när som helst återkalla behörigheter i inställningar.
            </p>
          </div>
        </div>
      </div>
      
      <div className="mt-auto pb-8">
        <Button
          onClick={handleContinue}
          variant="primary"
          size="large"
          fullWidth
        >
          Fortsätt
        </Button>
      </div>
    </div>
  );
}
